import { Link } from 'react-router-dom'
import FeaturesImage from '../assets/images/Features-image.JPG';

function Features() {
	return (
		<>
			<section className='text-gray-700 body-font border-t border-gray-200'>
				<div className='container px-5 py-24 mx-auto flex flex-wrap'>
					<div className='lg:w-1/2 w-full mb-10 lg:mb-0 rounded-lg overflow-hidden'>
						<img
							alt='feature'
							className='object-cover object-center h-full w-full'
							src={FeaturesImage}
						/>
					</div>
					<div className='flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center'>
						<div className='flex flex-col mb-10 lg:items-start items-center'>
							<div className='w-12 h-12 inline-flex items-center justify-center rounded-full bg-indigo-100 text-blue-500 mb-5'>
								<svg
									fill='none'
									stroke='currentColor'
									strokeLinecap='round'
									strokeLinejoin='round'
									strokeWidth='2'
									className='w-6 h-6'
									viewBox='0 0 24 24'>
									<path d='M22 12h-4l-3 9L9 3l-3 9H2'></path>
								</svg>
							</div>
							<div className='flex-grow'>
								<h2 className='text-gray-900 text-lg title-font font-medium mb-3'>
									Coinbase NFT
								</h2>
								<p className='leading-relaxed text-base'>
									Blue bottle crucifix vinyl post-ironic four
									dollar toast vegan taxidermy. Gastropub
									indxgo juice poutine.
								</p>
								<Link
									to='/'
									className='mt-3 text-blue-500 inline-flex items-center'>
									Learn More
									<svg
										fill='none'
										stroke='currentColor'
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
										className='w-4 h-4 ml-2'
										viewBox='0 0 24 24'>
										<path d='M5 12h14M12 5l7 7-7 7'></path>
									</svg>
								</Link>
							</div>
						</div>
						<div className='flex flex-col mb-10 lg:items-start items-center'>
							<div className='w-12 h-12 inline-flex items-center justify-center rounded-full bg-indigo-100 text-blue-500 mb-5'>
								<svg
									fill='none'
									stroke='currentColor'
									strokeLinecap='round'
									strokeLinejoin='round'
									strokeWidth='2'
									className='w-6 h-6'
									viewBox='0 0 24 24'>
									<circle cx='6' cy='6' r='3'></circle>
									<circle cx='6' cy='18' r='3'></circle>
									<path d='M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12'></path>
								</svg>
							</div>
							<div className='flex-grow'>
								<h2 className='text-gray-900 text-lg title-font font-medium mb-3'>
									Wallet
								</h2>
								<p className='leading-relaxed text-base'>
									Blue bottle crucifix vinyl post-ironic four
									dollar toast vegan taxidermy. Gastropub
									indxgo juice poutine.
								</p>
								<Link
									to='/'
									className='mt-3 text-blue-500 inline-flex items-center'>
									Learn More
									<svg
										fill='none'
										stroke='currentColor'
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
										className='w-4 h-4 ml-2'
										viewBox='0 0 24 24'>
										<path d='M5 12h14M12 5l7 7-7 7'></path>
									</svg>
								</Link>
							</div>
						</div>
						<div className='flex flex-col mb-10 lg:items-start items-center'>
							<div className='w-12 h-12 inline-flex items-center justify-center rounded-full bg-indigo-100 text-blue-500 mb-5'>
								<svg
									fill='none'
									stroke='currentColor'
									strokeLinecap='round'
									strokeLinejoin='round'
									strokeWidth='2'
									className='w-6 h-6'
									viewBox='0 0 24 24'>
									<path d='M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2'></path>
									<circle cx='12' cy='7' r='4'></circle>
								</svg>
							</div>
							<div className='flex-grow'>
								<h2 className='text-gray-900 text-lg title-font font-medium mb-3'>
									Card
								</h2>
								<p className='leading-relaxed text-base'>
									Blue bottle crucifix vinyl post-ironic four
									dollar toast vegan taxidermy. Gastropub
									indxgo juice poutine.
								</p>
								<Link
									to='/homepage'
									className='mt-3 text-blue-500 inline-flex items-center'>
									Learn More
									<svg
										fill='none'
										stroke='currentColor'
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
										className='w-4 h-4 ml-2'
										viewBox='0 0 24 24'>
										<path d='M5 12h14M12 5l7 7-7 7'></path>
									</svg>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}
export default Features
